export default __webpack_public_path__ + "static/hudson-bond-aa3209c221ac2235e7d2a410a88e26dd.png";